import whiteBrandTheme from "./whiteBrand";
import defaultTheme from "./default";

const getTheme = process.env.REACT_APP_THEME;

const setTheme = () => {
  if (getTheme) {
    if (getTheme === "white-brand") {
      return whiteBrandTheme;
    }
    return defaultTheme;
  }

  return defaultTheme;
};

export default setTheme();
